import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  create(): void {
    // Cargar assets mínimos y pasar a título
    this.scene.start('TitleScene');
  }
}
